import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../base/api-base.service';
import { LogoImageContractService } from '../interfaces/logo-image-contract.service';
import { NetworkStatusService } from '../network-status.service';
import { LogoImageOfflineService } from '../offline/logo-image-offline.service';
import { LogoImageOnlineService } from '../online/logo-image-online.service';

@Injectable({
  providedIn: 'root'
})
export class LogoImageService extends ApiService<LogoImageContractService> implements LogoImageContractService {

  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: LogoImageOfflineService,
    protected onlineService: LogoImageOnlineService
  ) {
    super(networkStatusService, offlineService, onlineService);
  }

  deleteLogo(): Observable<unknown> {
    return this.service.deleteLogo();
  }

  // LO01 /api/logo
  getLogoImage(): Observable<string | null> {
    return this.service.getLogoImage();
  }

  // LO02 /api/logo
  uploadLogoImage(file: File): Observable<unknown> {
    return this.service.uploadLogoImage(file);
  }
}
